export const InlineLoader = ({ className }: { className?: string }) => {
    const dotCss = 'absolute w-[13px] h-[13px] rounded-lg bg-brand ease-[cubic-bezier(0, 1, 1, 0)]';

    return (
        <div className={`relative inline-block h-5 w-20 rounded-lg ${className || ''}`}>
            <div className={`${dotCss} left-2 animate-dot1`} />
            <div className={`${dotCss} left-2 animate-dot2`} />
            <div className={`${dotCss} left-8 animate-dot2`} />
            <div className={`${dotCss} left-14 animate-dot3`} />
        </div>
    );
};
